export default __webpack_public_path__ + "static/media/pointer.604fe933.svg";